import client from './services/auth-client'
/* eslint-disable */
export const auth = {
   namespaced:true,
  state: {
    connectedUser:undefined,
      verification_errors:{},
      countries:[],
  },
  mutations: {
    SET_CONNECTED_USER(state,user){
      state.connectedUser = user
    },
      SET_COUNTRIES(state,countries){
      state.countries = countries
    },
      SET_VERIFICATION_ERROR(state,data){
      state.verification_errors.error = (data.error)?'error':'success';
      state.verification_errors.message = data.message
    }
  },
  actions: {
      register({commit},data) {
          let url = 'register';
          return new Promise((resolve, reject) => {
              client({
                  method: 'post',
                  url: url,
                  data:data,
              }).then((response) => {
                  resolve(response.data)
              }).catch((error) => {
                  reject(error)
              })
          })
      },
    async login({commit},data) {
          let url = 'login';
          return new Promise((resolve, reject) => {
              client({
                  method: 'post',
                  url: url,
                  data:data
              }).then((response) => {
                  if (!response.data.error){
                         let marchand = response.data.marchand;
                         let keys = response.data.keys;
                          commit('SET_CONNECTED_USER',response.data.user);
                          sessionStorage.setItem("user",JSON.stringify(response.data.user));
                          sessionStorage.setItem("token",response.data.token);
                          if(marchand!==null || marchand!==undefined)
                          sessionStorage.setItem("marchand",JSON.stringify(response.data.marchand));
                          if(keys!==null || keys!==undefined)
                          sessionStorage.setItem("keys",JSON.stringify(response.data.keys));
                          if (!localStorage.getItem('locale'))
                          localStorage.setItem("locale",JSON.stringify({name:'Français',locale:'fr'}))
                  }

                  resolve(response.data)
              }).catch((error) => {
                  reject(error)
              })
          })
      },
      sendResetMail({commit},data) {
          let url = 'password/reset';
          return new Promise((resolve, reject) => {
              client({
                  method: 'post',
                  url: url,data:data
              }).then((response) => {
                  resolve(response.data)
              }).catch((error) => {
                  reject(error)
              })
          })
      },
      resetPassword({commit},data) {
          let url = 'password/reset/'+data.route.id+'/'+data.route.token;
          return new Promise((resolve, reject) => {
              client({
                  method: 'post',
                  url: url,data:data.form
              }).then((response) => {
                  resolve(response.data)
              }).catch((error) => {
                  reject(error)
              })
          })
      },
      logout({commit}) {
          let url = 'logout';
          return new Promise((resolve, reject) => {
              client({
                  method: 'post',
                  url: url
              }).then((response) => {
                  if (!response.data.error)
                      commit('SET_CONNECTED_USER',undefined);
                  sessionStorage.clear();
                  resolve(response.data)
              }).catch((error) => {
                  reject(error)
              })
          })
      },
      getCountries({commit}){
          return new Promise((resolve,reject)=>{
              client({
                  method : 'get',
                  url:'/register/countries',
              })
                  .then((response)=>{
                      commit('SET_COUNTRIES',response.data.countries)
                  })
                  .catch((error)=>{
                      reject(error);
                  })
          })

      },
      verify({commit},token) {
          let url = 'verify/'+token;
          return new Promise((resolve, reject) => {
              client({
                  method: 'post',
                  url: url
              }).then((response) => {
                  commit('SET_VERIFICATION_ERROR',response.data);
                  resolve(response.data)
              }).catch((error) => {
                  reject(error)
              })
          })
      }
  },

};
